export default __webpack_public_path__ + "static/article-travel-short-notice-6342febfa74ca996a374dc698845f796.jpg";